/**
 * Ausgabe der SEO-Navigation im EditMode
 *
 * Dieses Script lässt die SEO Navigation im EditMode über ein Label öffnen und über ein Icon wieder schließen. Die SEO-
 * Navigation ist nur im EditMode Sichtbar.
 *
 * @param {string} selectorWrapper - Der Wrapper der SEO-Navigation.
 * @param {string} selectorLabel - Über das Label kann die SEO-Navigation aufgerufen werden.
 * @param {string} selectorIcon - Das Icon ist zum schließen der SEO-Navigation da.
 * Events: document.ready
 **/

function nc_initSeoNavigation(selectorWrapper, selectorLabel, selectorIcon) {
    var moduleLogger = LoggerManager.get('seo-navigation').setPrefix('SelectorWrapper: ' + selectorWrapper + 'SelectorLabel: ' + selectorLabel + 'SelectorIcon: ' + selectorIcon);
    moduleLogger.trace('INIT START');

    $(document).ready(function () {
        // Aufruf vom Script der SeoNavigation
        nc_SeoNavigation(selectorWrapper, selectorLabel, selectorIcon)
    });

    moduleLogger.info('INIT ENDE');
}


function nc_SeoNavigation(selectorWrapper, selectorLabel, selectorIcon) {
    var moduleLogger = LoggerManager.get('seo-navigation').setPrefix('SelectorWrapper: ' + selectorWrapper + 'SelectorLabel: ' + selectorLabel + 'SelectorIcon: ' + selectorIcon);
    moduleLogger.trace('SCRIPT START');

    // Wird das Label geklickt
    $(selectorLabel).click(function(){
        // bekommt der Wrapper der SEO-Navigation die Klasse open und das Menü ist sichtbar.
        $(selectorWrapper).toggleClass("open");
    });
    // Wird das Icon geklick
    $(selectorIcon).click(function(){
        // wird die oben hinzugefügte Klasse open wieder entfernt und das Menü ausgeblendet.
        $(selectorWrapper).toggleClass("open");
    });

    moduleLogger.info('SCRIPT ENDE');
}